import { IonList, IonItem, IonBadge } from '@ionic/react';
import { TeamUserCourseSummary } from '../../types/teamUserSummary';

interface CourseListProps {
  courses: TeamUserCourseSummary[];
}

export function CourseList({ courses }: CourseListProps) {
  const formatDate = (dateString: string) => {
    if (!dateString || dateString.trim() === '') {
      return 'No activity';
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return 'No activity';
    }
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <IonList>
      {/* Desktop Column Headers - Hidden on mobile */}
      <div className="hidden md:flex flex-col md:flex-row gap-4 w-full">
        <div className="flex-1">Course Name</div>
        <div className="flex-1">Progress</div>
        <div className="flex-1 text-right">Last Accessed</div>
      </div>

      {courses.map((course) => (
        <IonItem key={course.id} className="py-3">
          <div className="flex flex-col md:flex-row gap-3 md:gap-4 w-full">
            {/* Mobile: Stacked with labels, Desktop: Row layout */}
            <div className="flex-1 md:flex-1 flex justify-between items-center md:block">
              <span className="md:hidden font-medium text-gray-700">Course Name: </span>
              <span className="md:hidden">{course.name}{course.isCompleted && ' ✓'}</span>
              <span className="hidden md:inline">
                {course.name}
                {course.isCompleted && <span className="ml-2 text-green-600">✓</span>}
              </span>
            </div>

            <div className="flex-1 md:flex-1 flex justify-between items-center md:block">
              <span className="md:hidden font-medium text-gray-700">Progress: </span>
              <IonBadge color="primary" className="px-3 py-1.5 text-sm font-semibold">
                {course.progress}%
              </IonBadge>
            </div>

            <div className="flex-1 md:flex-1 flex justify-between items-center md:block md:text-right">
              <span className="md:hidden font-medium text-gray-700">Last Accessed: </span>
              <span className="text-gray-600 text-sm">
                {formatDate(course.lastAccessed)}
              </span>
            </div>
          </div>
        </IonItem>
      ))}
    </IonList>
  );
}
